import { render, staticRenderFns } from "./BannerDetail.vue?vue&type=template&id=1d3c11d0&scoped=true"
import script from "./BannerDetail.vue?vue&type=script&lang=js"
export * from "./BannerDetail.vue?vue&type=script&lang=js"
import style0 from "./BannerDetail.vue?vue&type=style&index=0&id=1d3c11d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3c11d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d3c11d0')) {
      api.createRecord('1d3c11d0', component.options)
    } else {
      api.reload('1d3c11d0', component.options)
    }
    module.hot.accept("./BannerDetail.vue?vue&type=template&id=1d3c11d0&scoped=true", function () {
      api.rerender('1d3c11d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/BannerDetail.vue"
export default component.exports